import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useState, SyntheticEvent, useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useKeyPress, useHelpModalState } from 'react-commons';
import { useGlobalState } from '../../../state/persistence';
import { useStyles } from '../../Shared';

const useAppartmentSize = (nextUrl: string) => {
  const { t } = useTranslation('apartment_size');
  const history = useHistory();
  const { dispatchQuestion } = useGlobalState();
  const { toggleHelpModal } = useHelpModalState();

  const [size, setSize] = useState<number>(25);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onBlur' });
  const enterPressed = useKeyPress('Enter');

  const onSizeChange = (e: SyntheticEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    setSize(Number(target.value));
  };

  const onSubmit = useCallback(() => {
    dispatchQuestion('apartmentSize', size);

    history.push(nextUrl);
  }, [size, dispatchQuestion, nextUrl, history]);

  useEffect(() => {
    if (enterPressed) onSubmit();
  }, [enterPressed, onSubmit]);

  const onChange = (e: MouseEvent, value: number) => {
    setSize(Number(value));
  };

  return {
    classes: useStyles(),
    t,
    toggleHelpModal,
    onChange,
    size,
    onSizeChange,
    register,
    errors,
    handleSubmit: handleSubmit(onSubmit),
  };
};

export default useAppartmentSize;
